import {CardLinkWrapper} from '@hconnect/uikit/src/lib2'
import {useUpmPlant} from '@hconnect/upm'
import {SxProps, Theme} from '@mui/material'
import {ExpertSystemUsageContainer} from '@widgets/expert-system'
import moment from 'moment-timezone'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type Props = {
  plantId: string
  shiftSummaryHref?: string
  cardBoxSx?: SxProps<Theme>
  placeholderWrapperSx?: SxProps<Theme>
}

export const ExpertSystemDailyContainer: React.FC<Props> = ({
  plantId,
  shiftSummaryHref,
  cardBoxSx,
  placeholderWrapperSx
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {upmId: upmPlantId, timezone} = useUpmPlant({plantId})
  const startOfToday = moment.utc().tz(timezone).startOf('day').toISOString()
  const endOfToday = moment.utc().tz(timezone).startOf('minute').toISOString()

  const cardContent = (
    <ExpertSystemUsageContainer
      hierarchyId={upmPlantId}
      from={startOfToday}
      to={endOfToday}
      timeRangeLabel={t('label.today')}
      cardBoxSx={cardBoxSx}
      placeholderWrapperSx={placeholderWrapperSx}
    />
  )

  if (shiftSummaryHref) {
    return (
      <CardLinkWrapper
        href={shiftSummaryHref}
        data-test-id="expert-system-card-link-to-shift-summary"
      >
        {cardContent}
      </CardLinkWrapper>
    )
  }

  return cardContent
}
